import { Injectable, Injector } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { environment } from '../../environments/environment';
import { CurrentUser } from '../security/current-user.model';
import { Router } from '@angular/router';
import { PlatformLocation } from '@angular/common';

import 'rxjs/add/operator/toPromise';
import { MatDialog } from '@angular/material';

@Injectable()
export class CurrentUserService {
  private serviceUrl = '';
  private setCookieUrl = '';
  private checkCookieUrl = '';
  private noOpUrl = '';
  private cookieName = 'CookieSettingsCheck';
  private myUrl = '';

  // this assumes that this app is on 
  public get loginSiteUrl(): string {
    if (environment.production) {
      let parseUri = require('parse-uri');
      let u = parseUri(window.location.href);
      let hostSegments = u.host.split(".");
      let apiHost = hostSegments[0] + "-api";
      for (let i = 1; i < hostSegments.length; i++) apiHost += "." + hostSegments[i];
      let url = u.protocol + "://" + apiHost + "/";
      return url;
    }
    else {
      return environment.loginSiteurl;
    }
  }


  private _user: CurrentUser;
  private _browserOk: boolean = false;

  constructor(private http: Http, private router: Router) {
    this.serviceUrl = this.loginSiteUrl + "api/userinfo/maxattributes";
    this.setCookieUrl = this.loginSiteUrl + "api/health/setcookie";
    this.checkCookieUrl = this.loginSiteUrl + "api/health/checkcookie";
    this.noOpUrl = this.loginSiteUrl + "api/health/noop";
    this.myUrl = window.location.origin;
  }

  public getDomain(url): string {
    var parseUri = require('parse-uri');
    var u = parseUri(url);
    return u.host;
  }

  public get user(): CurrentUser {
    return this._user;
  }

  public get browserOk(): boolean {
    return this._browserOk;
  }

  public get domain(): string {
    return this.getDomain(this.loginSiteUrl);
  }

  public get siteUrl(): string {
    return this.loginSiteUrl;
  }

  browserCheck(): Promise<boolean> {
    return this.http.get(this.noOpUrl, { withCredentials: false })
      .toPromise()
      .then(() => {
        return this.http.get(this.setCookieUrl)
          .toPromise()
          .then(response => {
            return this.http.get(this.checkCookieUrl)
              .toPromise().then(response => {
                this._browserOk = true;
                return true;
              })
          })
          .catch((error: Response) => {
            this._browserOk = false;
            this._user = null;
            return Promise.reject<boolean>("Domain " + this.getDomain(this.setCookieUrl) + " probably doesn't allow CORS from domain " + this.domain);
          });
      })
      .catch(error => {
        this._browserOk = false;
        this._user = null;
        return Promise.reject<boolean>("Can't reach site " + this.loginSiteUrl);
      });
  }

  preFlight(): Promise<any> {
    return this.http.options(this.serviceUrl)
      .toPromise()
      .then(response => { return response; })
      .catch(this.handleError);
  }

  // this is called internally when the loginout component is instantiated

  login(): Promise<CurrentUser> {
    return this.http.get(this.serviceUrl)
      .toPromise()
      .then(response => {
        var user: CurrentUser;
        user = response.json();
        user.displayName = user.firstName + ' ' + (user.middleName == '' ? ' ' : user.middleName + '. ') + user.lastName + user.orgTag;
        user.authenticationGroups = user.maxAuthenticationGroups.split(",")
        //console.log(user);
        this._user = user;
        this.router.navigate(['/']);
        return user;
      })
      .catch(this.handleError);
  }

  // this can be called to do a "soft" logout, e.g. after a later http call has failed with a 401

  logout() {
    this._user = null;
  }

  private handleError(error: any): Promise<any> {
    try {
      this.logout();
    }
    catch { }
    return Promise.reject(error.message || error);
  }

  // call this from click events, etc. from outside to log in/out

  browserLogin(login: boolean = true) {
    var url;

    if (login) {
      url = this.loginSiteUrl + environment.loginPage + "?url=" + encodeURIComponent(this.myUrl);
    }
    else {
      this._user = null;
      url = this.loginSiteUrl + environment.logoutPage + "?url=" + encodeURIComponent(this.myUrl);
    }
    window.open(url, '_self');
  }


}



// WEBPACK FOOTER //
// ./src/app/security/current-user.service.ts